/*
 *  Copyright (c) Qwoach LLC 2021. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 29/10/2021
 */

import {JournalEntryType} from "@shared/Journal/JournalEntryType";
import {JournalEntry} from "./journalEntry-imports";
import {Type} from "@qwoach/class-transformer-wrapper";
import {JournalEntryDiscriminator} from "@shared/Journal/JournalEntryDiscriminator";
import {ensureArray} from "@/utils/helpers";

export default class GroupJournalEntry extends JournalEntry {

	@Type(() => JournalEntry, JournalEntryDiscriminator)
	entries: JournalEntry[] = [];

	isVirtual: boolean = false; // Indicates if this is a virtual entry that is only used for visual representation. Non-empty virtual entries should not be saved to the database.

	// we include "type" to prevent it from being overridden
	// eslint-disable-next-line no-unused-vars
	constructor({date = null, entries = [], note = "", type = JournalEntryType.GROUP, isVirtual = false, ...rest} = {}) {
		super({type, date, entries, note, ...rest});
		this.summary = note || null
		this.date = date || null
		this.entries = entries || [];
		this.isVirtual = isVirtual || false
	}

	hasEntryType(entryType) {
		return this.getEntryArrayByType(entryType).length > 0
	}
	getEntryByType(entryType) {
		entryType = ensureArray(entryType)
		return this.entries.find((entry) => entryType.includes(entry.type))
	}

	getEntryArrayByType(entryType) {
		let res = []
		for(let entry of this.entries) {
			if (entry.type === entryType) {
				res.push(entry)
			}
		}
		return res
	}

	addEntry(journalEntry, {targetEntry, isAddBefore = true} = {}) {
		if(this.isVirtual){
			journalEntry.virtualGroupName = this.title
		}
		//TODO implement instertion logic before/after targetEntry
		// this.entries.splice(journalEntry);

		this.entries.push(journalEntry);
	}

	deleteEntry(entry){
		return this.entries.deleteItem(entry)
	}

	updateEntry(entry){
		const index = this.entries.findIndex(e => e.id === entry.id);
		if (index !== -1) {
			this.entries[index] = entry;
		}
		return index !== -1;
	}

	setTitle(title) {
		this.title = title;
		this.syncTitle()
	}

	syncTitle(){
		if(this.isVirtual){
			for(let entry of this.entries) {
				entry.virtualGroupName = this.title;
			}
		}
	}

	isEmpty(){
		return this.entries.length === 0
	}


}
